import { render, staticRenderFns } from "./OrderNotifications.vue?vue&type=template&id=01e84cb4&scoped=true&lang=pug&"
import script from "./OrderNotifications.vue?vue&type=script&lang=js&"
export * from "./OrderNotifications.vue?vue&type=script&lang=js&"
import style0 from "./OrderNotifications.vue?vue&type=style&index=0&id=01e84cb4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e84cb4",
  null
  
)

/* custom blocks */
import block0 from "./OrderNotifications.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports